import React, { useState, useMemo } from 'react';
import emailjs from '@emailjs/browser';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { uid } from '../utils/helpers';

const EJS_SERVICE  = process.env.REACT_APP_EMAILJS_SERVICE_ID           || '';
const EJS_CONVOC   = process.env.REACT_APP_EMAILJS_TEMPLATE_CONVOCATION  || '';
const EJS_KEY      = process.env.REACT_APP_EMAILJS_PUBLIC_KEY             || '';

const FO_RED = '#CC0000';

const MEMBRES_INIT = [
  { id: 'cs-01', genre: 'Madame',   prenom: 'Geneviève',  nom: 'FIDJI',        tel: '0692277249', email: 'genevieve.fidji@laposte.net',       association: 'IRSAM' },
  { id: 'cs-02', genre: 'Madame',   prenom: 'Lydie',       nom: 'BEGUE',        tel: '0692681567', email: 'lydiebegue@wanadoo.fr',              association: 'IRSAM' },
  { id: 'cs-03', genre: 'Madame',   prenom: 'Mirella',     nom: 'GOUMANE',      tel: '0692868472', email: 'madhumati974@gmail.com',             association: 'IRSAM' },
  { id: 'cs-04', genre: 'Monsieur', prenom: 'Alain',       nom: 'ANDREAS',      tel: '0692699394', email: 'andreas@wanadoo.fr',                 association: 'BIOTOP' },
  { id: 'cs-05', genre: 'Madame',   prenom: 'Louise',      nom: 'MAILLOT',      tel: '0692254808', email: 'louielvmaillot@gmail.com',           association: 'ARAR' },
  { id: 'cs-06', genre: 'Madame',   prenom: 'Graziella',   nom: 'GOULAND',      tel: '0692619474', email: 'gouland.graziella@gmail.com',        association: 'Fondation Père Favron' },
  { id: 'cs-07', genre: 'Madame',   prenom: 'Isabelle',    nom: 'AVABY',        tel: '0692857195', email: 'isabelleavavy@gmail.com',            association: 'Fondation Père Favron' },
  { id: 'cs-08', genre: 'Madame',   prenom: 'Leatitia',    nom: 'CATAGNA',      tel: '0692776690', email: 'lethikette@gmail.com',               association: 'Fondation Père Favron' },
  { id: 'cs-09', genre: 'Madame',   prenom: 'Sandrine',    nom: 'LEBON',        tel: '0692898578', email: 'sand.lebon@wanadoo.fr',              association: 'Fondation Père Favron' },
  { id: 'cs-10', genre: 'Monsieur', prenom: 'Samuel',      nom: 'MOREL',        tel: '0692219959', email: 'samleheros@yahoo.fr',                association: 'Fondation Père Favron' },
  { id: 'cs-11', genre: 'Madame',   prenom: 'Emmanuelle',  nom: 'FRAUMENS',     tel: '0692881462', email: 'ema.domitin@hotmail.fr',             association: 'Fondation Père Favron' },
  { id: 'cs-12', genre: 'Monsieur', prenom: 'Arnaud',      nom: 'LE DALL',      tel: '0692939012', email: 'arnoledall@gmail.com',               association: 'Fondation Père Favron' },
  { id: 'cs-13', genre: 'Monsieur', prenom: 'Alexandre',   nom: 'PAYET',        tel: '0692358380', email: 'manapany.vincendo@wanadoo.fr',       association: 'Fondation Père Favron' },
  { id: 'cs-14', genre: 'Monsieur', prenom: 'Ruddy',       nom: 'PAYET',        tel: '0692198002', email: 'ruddyalexandre974@gmail.com',        association: 'Fondation Père Favron' },
  { id: 'cs-15', genre: 'Monsieur', prenom: 'Stéphane',    nom: 'LEBON',        tel: '0692705725', email: 'steph.lebon974@gmail.com',           association: 'Fondation Père Favron' },
  { id: 'cs-16', genre: 'Monsieur', prenom: 'Patrice',     nom: 'DUPONT',       tel: '0692553219', email: 'patrice.dupont23@wanadoo.fr',        association: 'Fondation Père Favron' },
  { id: 'cs-17', genre: 'Madame',   prenom: 'Émilie',      nom: 'JOURDAIN',     tel: '0692775649', email: 'emilie.jourdain@gmail.com',          association: 'Fondation Père Favron' },
  { id: 'cs-18', genre: 'Madame',   prenom: 'Elodie',      nom: 'OMERALIE',     tel: '0692151437', email: 'elodieomerly5@gmail.com',            association: 'Fondation Père Favron' },
  { id: 'cs-19', genre: 'Madame',   prenom: 'Nelly',       nom: 'SARPEDON',     tel: '0692767981', email: '',                                   association: 'ALEFPA' },
  { id: 'cs-20', genre: 'Monsieur', prenom: 'George',      nom: 'GRONDIN',      tel: '',           email: 'georgesmarie.grondin@gmail.com',     association: '' },
  { id: 'cs-21', genre: 'Madame',   prenom: 'Evelyne',     nom: 'DELMAS',       tel: '',           email: 'evelyne.lepinay@orange.fr',          association: '' },
  { id: 'cs-22', genre: 'Madame',   prenom: 'Dominique',   nom: 'ST ALME',      tel: '',           email: 'dominiquesaitalme368@gmail.com',     association: 'Fondation Père Favron' },
  { id: 'cs-23', genre: 'Monsieur', prenom: 'Patrick',     nom: 'RAMIDGE BANE', tel: '0693026269', email: 'ramidgebanejeanmichel@gmail.com',    association: 'Croix Rouge' },
  { id: 'cs-24', genre: 'Monsieur', prenom: 'Fabrice',     nom: 'BOYER',        tel: '0692387291', email: 'boyyer974@yahoo.fr',                 association: 'Fondation Père Favron' },
  { id: 'cs-25', genre: 'Monsieur', prenom: 'Thomas',      nom: 'WAN YU KUNG',  tel: '0692064556', email: 'thomas.wan@hotmail.fr',              association: 'ADAPEI' },
  { id: 'cs-26', genre: 'Monsieur', prenom: 'Alain',       nom: 'LOMBARDIE',    tel: '0693423634', email: 'alainlombardie123@gmail.com',        association: 'Fondation Père Favron' },
];

export { MEMBRES_INIT };

function formatDateFR(dateStr) {
  if (!dateStr) return '_______________';
  const d = new Date(dateStr + 'T00:00:00');
  const jours = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
  const moisArr = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  return `${jours[d.getDay()]} ${d.getDate()} ${moisArr[d.getMonth()]} ${d.getFullYear()}`;
}

function buildLetterHTML(member, type, dateConvoc, dateReunion, logoUrl, sigUrl) {
  const genre = member.genre || 'Monsieur';
  const fullName = `${member.prenom} ${member.nom}`;
  const convoque = genre === 'Madame' ? 'convoquée' : 'convoqué';

  let destinataireBlock = '';
  let bodyBlock = '';

  if (type === 'sdassp') {
    destinataireBlock = `<strong>${genre} ${fullName}</strong><br>Membre du Conseil Syndical Départemental SDASSP FO Réunion`;
    bodyBlock = `
      <p>${genre} ${fullName},</p>
      <p>Je t'informe que le Conseil Syndical Départemental du <strong>S.D.A.S.S.P. – FO Réunion</strong> se réunira le :</p>
      <p class="center-bold">${formatDateFR(dateReunion)}</p>
      <p>L'ordre du jour te sera communiqué dans les meilleurs délais.</p>
      <p>Nous comptons vivement sur ta présence.</p>
      <p>Dans l'attente de te voir, nous te prions, camarade, d'agréer nos salutations syndicales.</p>`;
  } else if (type === 'cor') {
    destinataireBlock = `<strong>${genre} ${fullName}</strong><br>Représentant Force Ouvrière au Conseil d'Orientation Régional<br>de la Région Île de La Réunion`;
    bodyBlock = `
      <p>Je soussigné Stéphane LEBON, Secrétaire Général du SDASSP FO Réunion, certifie que :</p>
      <p>${genre} ${fullName}, est bien ${convoque} à une journée de travail en sa qualité de représentant Force Ouvrière au Conseil d'Orientation Régional de la Région Île de La Réunion :</p>
      <p class="center-bold">${formatDateFR(dateReunion)}</p>
      <p>Ceci, dans le cadre des dispositions de :<br>
      &nbsp;&nbsp;- L'article 20.12 de l'accord de Branche du 7 mai 2015 et de ses avenants,<br>
      &nbsp;&nbsp;- L'article 2.4.2 ; 2.4.3 de la CCNT51,</p>`;
  } else {
    destinataireBlock = `<strong>${genre} ${fullName}</strong><br>Représentant Force Ouvrière à la Délégation Régionale CPNE-FP Réunion`;
    bodyBlock = `
      <p>Je soussigné Stéphane LEBON, Secrétaire Général du SDASSP FO Réunion, certifie que :</p>
      <p>${genre} ${fullName}, est bien ${convoque} à une journée de travail en sa qualité de représentant Force Ouvrière à la Délégation Régionale CPNE-FP le :</p>
      <p class="center-bold">${formatDateFR(dateReunion)}</p>
      <p>Ceci, dans le cadre des dispositions de :<br>
      &nbsp;&nbsp;- L'article 20.12 de l'accord de Branche du 7 mai 2015 et de ses avenants,<br>
      &nbsp;&nbsp;- L'article 2.4.2 ; 2.4.3 de la CCNT51,</p>`;
  }

  return `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="utf-8">
  <title>Convocation — ${fullName}</title>
  <style>
    @page { size: A4; margin: 0; }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: Arial, Helvetica, sans-serif; font-size: 12pt; background: white; }
    .page { width: 210mm; min-height: 297mm; display: flex; flex-direction: column; }
    .header { background: #fff; display: flex; align-items: center; gap: 20px; padding: 14px 28px 0; border-bottom: 4px solid #CC0000; }
    .header-logo { background: transparent; padding: 0 0 10px 0; width: 88px; height: 88px; display: flex; align-items: center; justify-content: flex-start; flex-shrink: 0; }
    .header-logo img { width: 88px; height: 88px; object-fit: contain; }
    .header-right { flex: 1; padding-bottom: 10px; }
    .header-title { color: #CC0000; font-size: 15pt; font-weight: 900; line-height: 1.3; text-transform: uppercase; letter-spacing: .3px; }
    .header-sub { color: #333; font-size: 9pt; margin-top: 3px; }
    .header-addr { color: #666; font-size: 8pt; margin-top: 2px; }
    .body { padding: 30px 44px 0; flex: 1; display: flex; flex-direction: column; }
    .destinataire { margin-bottom: 24px; font-size: 12pt; line-height: 1.65; }
    .date-letter { margin-bottom: 24px; font-size: 11pt; }
    .convoc-banner { background: #CC0000; color: white; border: none; text-align: center; font-weight: 900; font-size: 14pt; padding: 8px 36px; margin: 0 auto 24px; display: table; letter-spacing: 2px; border-radius: 2px; }
    .letter-body { flex: 1; }
    .letter-body p { margin-bottom: 14px; line-height: 1.75; text-align: justify; }
    .center-bold { text-align: center !important; font-weight: bold; font-size: 13pt; margin: 20px 0 !important; }
    .signature { text-align: right; margin-top: 36px; font-size: 11pt; line-height: 1.9; display: flex; flex-direction: column; align-items: flex-end; }
    .sig-area { position: relative; width: 230px; min-height: 90px; margin-bottom: 6px; display: flex; align-items: center; justify-content: flex-end; }
    .stamp-box { border: 2.5px solid #000; padding: 7px 13px; font-family: 'Courier New', monospace; font-size: 9pt; line-height: 1.7; transform: rotate(-4deg); display: inline-block; text-align: center; }
    .stamp-box strong { font-size: 10.5pt; display: block; letter-spacing: .5px; }
    .sig-photo { position: absolute; top: -5px; right: -5px; width: 200px; height: 110px; object-fit: contain; }
    .sig-name { font-weight: bold; font-size: 12pt; }
    .footer-3r { display: flex; justify-content: space-between; margin-top: 32px; font-size: 12pt; font-weight: bold; }
    .footer-3r em { color: #CC0000; font-style: normal; }
    .footer-bottom { margin-top: 14px; padding: 10px 0 20px; border-top: 2px solid #CC0000; display: flex; flex-direction: column; align-items: center; gap: 6px; }
    .footer-bottom img { height: 44px; }
    .footer-bottom p { font-size: 10pt; text-align: center; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
  </style>
</head>
<body>
<div class="page">
  <div class="header">
    <div class="header-logo"><img src="${logoUrl}" alt="FO Réunion"></div>
    <div class="header-right">
      <div class="header-title">S.D.A.S.S.P.</div>
      <div class="header-sub">Syndicat Départemental de l’Action Sociale et de la Santé Privée — FO Réunion</div>
      <div class="header-addr">7 Bis Impasse des Oeillets — 97480 Saint-Joseph — Tél. : 0692 XX XX XX</div>
    </div>
  </div>
  <div class="body">
    <div class="destinataire">${destinataireBlock}</div>
    <div class="date-letter">Saint Joseph, le ${formatDateFR(dateConvoc)}</div>
    <div class="convoc-banner">CONVOCATION</div>
    <div class="letter-body">${bodyBlock}</div>
    <div class="signature">
      <div class="sig-name">Stéphane LEBON</div>
      <div style="font-size:10pt;color:#555;margin-bottom:10px">Secrétaire Général — SDASSP FO Réunion</div>
      <div class="sig-area">
        <div class="stamp-box">
          <strong>S.D.A.S.S.P.</strong>
          <strong>FO / Réunion</strong>
          7 Bis Impasse des Oeillets<br>97480 SAINT-JOSEPH
        </div>
        <img class="sig-photo" src="${sigUrl}" alt="Signature SDASSP" onerror="this.style.display='none'">
      </div>
    </div>
    <div class="footer-3r">
      <span><em>R</em>ÉSISTER</span>
      <span><em>R</em>EVENDIQUER</span>
      <span><em>R</em>ECONQUÉRIR</span>
    </div>
    <div class="footer-bottom">
      <img src="${logoUrl}" alt="FO">
      <p>Syndicat Départemental de l'Action Sociale et de la Santé Privée FO Réunion</p>
    </div>
  </div>
</div>
<script>window.onload=function(){setTimeout(function(){window.print();},400);};<\/script>
</body>
</html>`;
}

const TYPE_LABELS = {
  sdassp: '🏛️ Conseil Syndical SDASSP',
  cor:    '🌐 COR — Conseil d\'Orientation Régional',
  drcpne: '📋 DRCPNE — CPNE-FP Réunion',
};

const TYPE_COLORS = { sdassp: '#fff3cd', cor: '#d1ecf1', drcpne: '#d4edda' };

export default function ConseilSyndical({ conseilMembers, convocations, saveConseilMember, deleteConseilMember, addConvocation, deleteConvocationsForMember, resetConvocationsForYear, selectedYear }) {
  const [subView, setSubView] = useState('membres');
  const [showEdit, setShowEdit] = useState(false);
  const [editMember, setEditMember] = useState(null);
  const [convForm, setConvForm] = useState({
    type: 'sdassp',
    selectedIds: [],
    dateConvoc: new Date().toISOString().slice(0, 10),
    dateReunion: '',
  });
  const [convError, setConvError] = useState('');
  const [emailStatus, setEmailStatus] = useState('idle'); // idle | sending | sent | error
  const [emailMsg, setEmailMsg] = useState('');

  const yr = selectedYear || new Date().getFullYear();

  const stats = useMemo(() => {
    const thisYr = convocations.filter(c => new Date(c.createdAt).getFullYear() === yr);
    return {
      total: convocations.length,
      thisYear: thisYr.length,
      sdassp: thisYr.filter(c => c.type === 'sdassp').length,
      cor: thisYr.filter(c => c.type === 'cor').length,
      drcpne: thisYr.filter(c => c.type === 'drcpne').length,
    };
  }, [convocations, yr]);

  const memberCounts = useMemo(() => {
    const counts = {};
    convocations
      .filter(c => new Date(c.createdAt).getFullYear() === yr)
      .forEach(c => {
        if (!counts[c.memberId]) counts[c.memberId] = { sdassp: 0, cor: 0, drcpne: 0, total: 0 };
        counts[c.memberId][c.type] = (counts[c.memberId][c.type] || 0) + 1;
        counts[c.memberId].total++;
      });
    return counts;
  }, [convocations, yr]);

  const base    = window.location.origin + (process.env.PUBLIC_URL || '');
  const logoUrl = base + '/fo-logo.png';
  const sigUrl  = base + '/signature-sdassp.png';

  const handleSendEmail = async () => {
    setConvError('');
    const { type, selectedIds, dateConvoc, dateReunion } = convForm;
    if (!dateReunion) { setConvError('Veuillez renseigner la date de réunion.'); return; }
    if (!EJS_SERVICE || !EJS_CONVOC || !EJS_KEY) {
      setConvError('Configuration EmailJS manquante (REACT_APP_EMAILJS_TEMPLATE_CONVOCATION).');
      return;
    }
    const targets = type === 'sdassp' && selectedIds.length === 0
      ? conseilMembers
      : conseilMembers.filter(m => selectedIds.includes(m.id));
    const withEmail = targets.filter(m => m.email);
    if (withEmail.length === 0) { setConvError('Aucun membre sélectionné avec une adresse mail.'); return; }

    setEmailStatus('sending');
    setEmailMsg('');
    let ok = 0, ko = 0;
    for (const m of withEmail) {
      try {
        await emailjs.send(EJS_SERVICE, EJS_CONVOC, {
          to_email:     m.email,
          to_name:      `${m.genre} ${m.prenom} ${m.nom}`,
          genre:        m.genre,
          prenom:       m.prenom,
          nom:          m.nom,
          association:  m.association || '',
          type_label:   TYPE_LABELS[type] || type,
          date_convoc:  formatDateFR(dateConvoc),
          date_reunion: formatDateFR(dateReunion),
        }, EJS_KEY);
        ok++;
        addConvocation({ id: uid(), memberId: m.id, memberName: `${m.prenom} ${m.nom}`, type, dateConvoc, dateReunion, createdAt: new Date().toISOString() });
      } catch { ko++; }
    }
    if (ko === 0) {
      setEmailStatus('sent');
      setEmailMsg(`✅ ${ok} mail${ok > 1 ? 's' : ''} envoyé${ok > 1 ? 's' : ''} avec succès.`);
    } else {
      setEmailStatus('error');
      setEmailMsg(`⚠️ ${ok} envoyé${ok > 1 ? 's' : ''}, ${ko} échec${ko > 1 ? 's' : ''}.`);
    }
    setTimeout(() => { setEmailStatus('idle'); setEmailMsg(''); }, 5000);
  };

  const doPrint = (member, type, dateConvoc, dateReunion) => {
    const html = buildLetterHTML(member, type, dateConvoc, dateReunion, logoUrl, sigUrl);
    const w = window.open('', '_blank', 'width=860,height=1120');
    if (w) { w.document.write(html); w.document.close(); }
    addConvocation({
      id: uid(),
      memberId: member.id,
      memberName: `${member.prenom} ${member.nom}`,
      type,
      dateConvoc,
      dateReunion,
      createdAt: new Date().toISOString(),
    });
  };

  const doDownloadPDF = async (member, type, dateConvoc, dateReunion) => {
    const html = buildLetterHTML(member, type, dateConvoc, dateReunion, logoUrl, sigUrl);
    const container = document.createElement('div');
    container.style.cssText = 'position:fixed;left:-9999px;top:0;width:794px;background:#fff;z-index:-1;';
    container.innerHTML = html;
    document.body.appendChild(container);
    try {
      const canvas = await html2canvas(container, { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false });
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdfW = 210, pdfH = (canvas.height * 210) / canvas.width;
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfW, pdfH);
      const filename = `Convocation_${member.nom}_${member.prenom}.pdf`;
      pdf.save(filename);
      addConvocation({ id: uid(), memberId: member.id, memberName: `${member.prenom} ${member.nom}`, type, dateConvoc, dateReunion, createdAt: new Date().toISOString() });
    } finally {
      document.body.removeChild(container);
    }
  };

  const handleGenerate = async () => {
    setConvError('');
    const { type, selectedIds, dateConvoc, dateReunion } = convForm;
    if (!dateReunion) { setConvError('Veuillez renseigner la date de réunion.'); return; }
    const targets = type === 'sdassp' && selectedIds.length === 0
      ? conseilMembers
      : conseilMembers.filter(m => selectedIds.includes(m.id));
    if (targets.length === 0) { setConvError('Aucun membre sélectionné.'); return; }
    setEmailStatus('sending');
    setEmailMsg(`Génération de ${targets.length} PDF en cours...`);
    for (const m of targets) {
      await doDownloadPDF(m, type, dateConvoc, dateReunion);
    }
    setEmailStatus('sent');
    setEmailMsg(`✅ ${targets.length} PDF nominatif${targets.length > 1 ? 's' : ''} téléchargé${targets.length > 1 ? 's' : ''}.`);
    setTimeout(() => { setEmailStatus('idle'); setEmailMsg(''); }, 5000);
  };

  const toggleId = (id) => {
    setConvForm(f => ({
      ...f,
      selectedIds: f.selectedIds.includes(id) ? f.selectedIds.filter(x => x !== id) : [...f.selectedIds, id],
    }));
  };

  const openAdd = () => {
    setEditMember({ genre: 'Monsieur', prenom: '', nom: '', tel: '', email: '', association: '' });
    setShowEdit(true);
  };

  const openEdit = (m) => { setEditMember({ ...m }); setShowEdit(true); };

  const histYear = [...convocations].reverse().filter(c => new Date(c.createdAt).getFullYear() === yr);

  return (
    <div className="page-container">
      {/* Header */}
      <div className="cs-header">
        <h1 className="page-title">⚖️ Conseil Syndical</h1>
        <div className="cs-tabs">
          {[
            { id: 'membres',      label: '👥 Membres' },
            { id: 'convocation',  label: '📄 Convocation' },
            { id: 'historique',   label: `📋 Historique (${stats.thisYear})` },
          ].map(t => (
            <button key={t.id} className={`btn ${subView === t.id ? 'btn-primary' : 'btn-outline'}`} onClick={() => setSubView(t.id)}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* KPI strip */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        <div style={{
          background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8,
          padding: '14px 24px', textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,.05)',
        }}>
          <div style={{ fontSize: 20, marginBottom: 4 }}>👥</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: '#111' }}>{conseilMembers.length}</div>
          <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>Membres</div>
        </div>
      </div>

      {/* ── MEMBRES ── */}
      {subView === 'membres' && (
        <div className="card">
          <div className="card-header">
            <span className="card-title">Membres du Conseil Syndical ({conseilMembers.length})</span>
            <div style={{ display: 'flex', gap: 6 }}>
            <button className="btn btn-primary btn-sm" onClick={openAdd}>+ Ajouter un membre</button>
            <button className="btn btn-outline btn-sm" style={{ color: '#c62828', borderColor: '#ef9a9a' }}
              onClick={() => { if (window.confirm(`Remettre à zéro tous les compteurs ${yr} ?`)) resetConvocationsForYear(yr); }}>
              🔄 Reset {yr}
            </button>
          </div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="cs-member-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  {['Genre','Prénom NOM','Association','Tél / Email'].map(h => (
                    <th key={h} style={{ padding: '9px 12px', textAlign: 'left', fontWeight: 700, borderBottom: '2px solid #eee', whiteSpace: 'nowrap' }}>{h}</th>
                  ))}
                  <th className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center', fontWeight: 700, borderBottom: '2px solid #eee', whiteSpace: 'nowrap', color: '#856404' }}>CSD</th>
                  <th className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center', fontWeight: 700, borderBottom: '2px solid #eee', whiteSpace: 'nowrap', color: '#0c5460' }}>COR</th>
                  <th className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center', fontWeight: 700, borderBottom: '2px solid #eee', whiteSpace: 'nowrap', color: '#155724' }}>DRCPNE</th>
                  <th className="cs-action-col" style={{ padding: '9px 12px', textAlign: 'left', fontWeight: 700, borderBottom: '2px solid #eee' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {conseilMembers.map((m, i) => {
                  const cnt = memberCounts[m.id] || { sdassp: 0, cor: 0, drcpne: 0, total: 0 };
                  const hasCounts = cnt.total > 0;
                  return (
                    <tr key={m.id} style={{ borderBottom: '1px solid #f5f5f5', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={{ padding: '9px 12px', color: '#888', fontSize: 12 }}>{m.genre}</td>
                      <td style={{ padding: '9px 12px', fontWeight: 600 }}>{m.prenom} {m.nom}</td>
                      <td style={{ padding: '9px 12px', fontSize: 12 }}>{m.association || <span style={{ color: '#ccc' }}>—</span>}</td>
                      <td style={{ padding: '9px 12px', fontSize: 11, color: '#666' }}>
                        {m.tel && <div>{m.tel}</div>}
                        {m.email && <div style={{ color: '#888' }}>{m.email}</div>}
                        {!m.tel && !m.email && <span style={{ color: '#ccc' }}>—</span>}
                      </td>
                      <td className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-block', minWidth: 24, padding: '2px 6px', borderRadius: 12,
                          background: cnt.sdassp > 0 ? '#fff3cd' : '#f5f5f5',
                          color: cnt.sdassp > 0 ? '#856404' : '#bbb',
                          fontWeight: cnt.sdassp > 0 ? 700 : 400, fontSize: 12,
                        }}>{cnt.sdassp}</span>
                      </td>
                      <td className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-block', minWidth: 24, padding: '2px 6px', borderRadius: 12,
                          background: cnt.cor > 0 ? '#d1ecf1' : '#f5f5f5',
                          color: cnt.cor > 0 ? '#0c5460' : '#bbb',
                          fontWeight: cnt.cor > 0 ? 700 : 400, fontSize: 12,
                        }}>{cnt.cor}</span>
                      </td>
                      <td className="cs-count-col" style={{ padding: '9px 8px', textAlign: 'center' }}>
                        <span style={{
                          display: 'inline-block', minWidth: 24, padding: '2px 6px', borderRadius: 12,
                          background: cnt.drcpne > 0 ? '#d4edda' : '#f5f5f5',
                          color: cnt.drcpne > 0 ? '#155724' : '#bbb',
                          fontWeight: cnt.drcpne > 0 ? 700 : 400, fontSize: 12,
                        }}>{cnt.drcpne}</span>
                      </td>
                      <td className="cs-action-col" style={{ padding: '9px 8px' }}>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn-icon" title="Préparer une convocation pour ce membre" onClick={() => {
                            const dt = new Date().toISOString().slice(0,10);
                            setConvForm(f => ({ ...f, selectedIds: [m.id], type: 'sdassp', dateConvoc: dt }));
                            setSubView('convocation');
                          }}>📄</button>
                          <button className="btn-icon" title="Modifier les informations du membre" onClick={() => openEdit(m)}>✏️</button>
                          <button
                            className="btn btn-outline btn-xs"
                            style={{ fontSize: 11, color: hasCounts ? '#c62828' : '#bbb', borderColor: hasCounts ? '#ef9a9a' : '#ddd' }}
                            title={hasCounts ? `Remettre à zéro les convocations de ${m.prenom} ${m.nom} (${yr})` : `Aucune convocation en ${yr}`}
                            disabled={!hasCounts}
                            onClick={() => { if (window.confirm(`Remettre à zéro les compteurs de ${m.prenom} ${m.nom} pour ${yr} ?`)) deleteConvocationsForMember(m.id, yr); }}>
                            🔄 Reset
                          </button>
                          <button className="btn-icon" title="Supprimer ce membre" onClick={() => {
                            if (window.confirm(`Supprimer ${m.prenom} ${m.nom} ?`)) deleteConseilMember(m.id);
                          }}>🗑️</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ── CONVOCATION ── */}
      {subView === 'convocation' && (
        <div className="cs-convoc-grid">
          {/* Form */}
          <div className="card" style={{ padding: 20 }}>
            <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>📄 Paramètres</div>

            <div className="form-group">
              <label className="form-label">Type de convocation</label>
              <select className="form-control" value={convForm.type}
                onChange={e => setConvForm(f => ({ ...f, type: e.target.value, selectedIds: [] }))}>
                <option value="sdassp">🏛️ Conseil Syndical SDASSP</option>
                <option value="cor">COR — Conseil d'Orientation Régional</option>
                <option value="drcpne">DRCPNE — CPNE-FP Réunion</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Date du courrier</label>
              <input type="date" className="form-control" value={convForm.dateConvoc}
                onChange={e => setConvForm(f => ({ ...f, dateConvoc: e.target.value }))} />
            </div>

            <div className="form-group">
              <label className="form-label">Date de la réunion *</label>
              <input type="date" className="form-control" value={convForm.dateReunion}
                onChange={e => setConvForm(f => ({ ...f, dateReunion: e.target.value }))} />
            </div>

            {convForm.type === 'sdassp' && (
              <div style={{ background: '#f0f8ff', border: '1px solid #b8d9f5', borderRadius: 6, padding: '10px 12px', fontSize: 12, marginBottom: 12, color: '#0c5460' }}>
                ℹ️ Laissez vide = tous les membres ({conseilMembers.length}) convoqués.
              </div>
            )}

            {convError && (
              <div style={{ background: '#fff5f5', border: '1px solid #f5c6cb', borderRadius: 6, padding: '8px 12px', fontSize: 12, marginBottom: 12, color: '#721c24' }}>
                ⚠️ {convError}
              </div>
            )}

            <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleGenerate}>
              🖨️ Générer &amp; Imprimer
              {convForm.selectedIds.length > 0
                ? ` (${convForm.selectedIds.length})`
                : convForm.type === 'sdassp' ? ` (${conseilMembers.length})` : ''}
            </button>

            <button className="btn btn-outline" style={{ width: '100%', marginTop: 8 }}
              disabled={emailStatus === 'sending'}
              onClick={handleSendEmail}>
              {emailStatus === 'sending' ? '⏳ Envoi en cours…' : '📧 Envoyer par mail'}
              {emailStatus === 'idle' && convForm.selectedIds.length > 0 ? ` (${convForm.selectedIds.length})` : ''}
            </button>

            {emailMsg && (
              <div style={{
                marginTop: 8, padding: '8px 12px', borderRadius: 6, fontSize: 12,
                background: emailStatus === 'sent' ? '#d4edda' : '#fff3cd',
                color: emailStatus === 'sent' ? '#155724' : '#856404',
                border: `1px solid ${emailStatus === 'sent' ? '#c3e6cb' : '#ffeeba'}`,
              }}>{emailMsg}</div>
            )}

            {convForm.selectedIds.length > 0 && (
              <button className="btn btn-outline btn-sm" style={{ width: '100%', marginTop: 8 }}
                onClick={() => setConvForm(f => ({ ...f, selectedIds: [] }))}>
                Effacer sélection
              </button>
            )}
          </div>

          {/* Member picker */}
          <div className="card">
            <div className="card-header">
              <span className="card-title">
                {convForm.type === 'sdassp'
                  ? `Membres (${convForm.selectedIds.length > 0 ? convForm.selectedIds.length + ' sélectionnés' : 'tous'})`
                  : 'Choisir le membre représentant'}
              </span>
              {convForm.type === 'sdassp' && (
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-outline btn-sm" onClick={() => setConvForm(f => ({ ...f, selectedIds: conseilMembers.map(m => m.id) }))}>
                    Tout
                  </button>
                  <button className="btn btn-outline btn-sm" onClick={() => setConvForm(f => ({ ...f, selectedIds: [] }))}>
                    Aucun
                  </button>
                </div>
              )}
            </div>
            <div style={{ maxHeight: 500, overflowY: 'auto' }}>
              {conseilMembers.map(m => {
                const sel = convForm.selectedIds.includes(m.id);
                return (
                  <div key={m.id} onClick={() => {
                    if (convForm.type === 'sdassp') toggleId(m.id);
                    else setConvForm(f => ({ ...f, selectedIds: [m.id] }));
                  }} style={{
                    padding: '10px 16px', cursor: 'pointer',
                    borderBottom: '1px solid #f5f5f5',
                    borderLeft: `4px solid ${sel ? FO_RED : 'transparent'}`,
                    background: sel ? '#fff5f5' : 'transparent',
                    display: 'flex', alignItems: 'center', gap: 10, transition: 'all .1s',
                  }}>
                    <input
                      type={convForm.type === 'sdassp' ? 'checkbox' : 'radio'}
                      readOnly checked={sel}
                      style={{ accentColor: FO_RED, flexShrink: 0 }}
                    />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{m.genre} {m.prenom} {m.nom}</div>
                      <div style={{ fontSize: 11, color: '#aaa', marginTop: 1 }}>{m.association || '—'}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* ── HISTORIQUE ── */}
      {subView === 'historique' && (() => {
        const memberGroups = conseilMembers.map(m => ({
          member: m,
          convocs: histYear.filter(c => c.memberId === m.id),
          cnt: memberCounts[m.id] || { sdassp: 0, cor: 0, drcpne: 0, total: 0 },
        })).filter(g => g.convocs.length > 0);
        return (
        <div>
          {/* Per-member stat badges */}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
            {conseilMembers.map(m => {
              const cnt = memberCounts[m.id];
              if (!cnt || cnt.total === 0) return null;
              return (
                <div key={m.id} style={{
                  background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8,
                  padding: '8px 14px', fontSize: 12, boxShadow: '0 1px 4px rgba(0,0,0,.05)',
                }}>
                  <div style={{ fontWeight: 700, color: '#222', marginBottom: 4 }}>{m.prenom} {m.nom}</div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {cnt.sdassp > 0 && <span style={{ background: '#fff3cd', color: '#856404', borderRadius: 10, padding: '1px 7px', fontWeight: 700 }}>CSD {cnt.sdassp}</span>}
                    {cnt.cor > 0 && <span style={{ background: '#d1ecf1', color: '#0c5460', borderRadius: 10, padding: '1px 7px', fontWeight: 700 }}>COR {cnt.cor}</span>}
                    {cnt.drcpne > 0 && <span style={{ background: '#d4edda', color: '#155724', borderRadius: 10, padding: '1px 7px', fontWeight: 700 }}>DRCPNE {cnt.drcpne}</span>}
                  </div>
                </div>
              );
            })}
            {histYear.length === 0 && <div style={{ color: '#bbb', fontSize: 13 }}>Aucune convocation en {yr}.</div>}
          </div>

          {/* Grouped table by member */}
          {memberGroups.map(({ member: m, convocs }) => (
            <div key={m.id} className="card" style={{ marginBottom: 12 }}>
              <div className="card-header">
                <span className="card-title" style={{ fontSize: 14 }}>
                  {m.genre} {m.prenom} {m.nom}
                  <span style={{ marginLeft: 8, fontSize: 12, fontWeight: 400, color: '#888' }}>{m.association}</span>
                </span>
                <span style={{ fontSize: 12, color: '#888' }}>{convocs.length} convocation{convocs.length > 1 ? 's' : ''}</span>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f8f8f8' }}>
                    {['Date émission','Type','Date réunion'].map(h => (
                      <th key={h} style={{ padding: '7px 12px', textAlign: 'left', fontWeight: 600, borderBottom: '1px solid #eee', color: '#666' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {convocs.map((c, j) => (
                    <tr key={c.id} style={{ borderBottom: '1px solid #f5f5f5', background: j % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <td style={{ padding: '8px 12px', color: '#777', fontSize: 12 }}>{formatDateFR(c.dateConvoc)}</td>
                      <td style={{ padding: '8px 12px' }}>
                        <span style={{
                          background: TYPE_COLORS[c.type] || '#eee',
                          padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700,
                        }}>{c.type.toUpperCase()}</span>
                      </td>
                      <td style={{ padding: '8px 12px', fontSize: 12 }}>{c.dateReunion ? formatDateFR(c.dateReunion) : <span style={{ color: '#ccc' }}>—</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      );
    })()}

      {/* Edit/Add modal */}
      {showEdit && editMember && (
        <MemberEditModal
          member={editMember}
          onChange={setEditMember}
          onSave={() => {
            if (!editMember.prenom.trim() || !editMember.nom.trim()) return;
            saveConseilMember(editMember);
            setShowEdit(false);
            setEditMember(null);
          }}
          onClose={() => { setShowEdit(false); setEditMember(null); }}
        />
      )}
    </div>
  );
}

function MemberEditModal({ member, onChange, onSave, onClose }) {
  const isNew = !member.id || member.id === undefined;
  const set = (k, v) => onChange(m => ({ ...m, [k]: v }));

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <span className="modal-title">{isNew ? '➕ Ajouter un membre' : '✏️ Modifier le membre'}</span>
          <button className="btn-icon" onClick={onClose}>✕</button>
        </div>

        <div className="form-group">
          <label className="form-label">Genre</label>
          <select className="form-control" value={member.genre} onChange={e => set('genre', e.target.value)}>
            <option value="Monsieur">Monsieur</option>
            <option value="Madame">Madame</option>
          </select>
        </div>

        <div className="grid-2">
          <div className="form-group">
            <label className="form-label">Prénom *</label>
            <input className="form-control" value={member.prenom} onChange={e => set('prenom', e.target.value)} placeholder="Prénom" />
          </div>
          <div className="form-group">
            <label className="form-label">NOM *</label>
            <input className="form-control" value={member.nom} onChange={e => set('nom', e.target.value.toUpperCase())} placeholder="NOM" />
          </div>
        </div>

        <div className="grid-2">
          <div className="form-group">
            <label className="form-label">Téléphone</label>
            <input className="form-control" value={member.tel} onChange={e => set('tel', e.target.value)} placeholder="06..." />
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-control" value={member.email} onChange={e => set('email', e.target.value)} placeholder="email@..." />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Association / Structure</label>
          <input className="form-control" value={member.association} onChange={e => set('association', e.target.value)} placeholder="Fondation Père Favron, IRSAM..." />
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Annuler</button>
          <button className="btn btn-primary" onClick={onSave} disabled={!member.prenom.trim() || !member.nom.trim()}>
            {isNew ? 'Ajouter' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
}
